/**
 * @fileoverview
 * @suppress {globalThis}
 */
